// ReturnIcon的图标
const ReturnIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.2 4H16.8L20 8.8V20H4V8.8L7.2 4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path d="M4 9H20" stroke="currentColor" strokeWidth="2" />
      <path d="M17 15H9L10 13" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 4L12 9" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}

export default ReturnIcon
